import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"

const productPaymentAdapter = createEntityAdapter()
export const initialState = productPaymentAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const productPaymentSlice = createSlice({
  name: "product-payment",
  initialState,
  reducers: {},
})

export const selectFetchStatus = (state: RootState) =>
  state.features.product_payment.fetchStatus

export default productPaymentSlice.reducer
